import React, { useState, useEffect } from "react";
import Layout from "../../layout/realestateagent/Layout";
import AgentBanner from "../../layout/realestateagent/Profile/AgentBanner";
import useAuthStore from "../../store/useAuthStore";
import { axiosInstancev1 } from "../../lib/axiosInstance";

const Profile = () => {
    const user = useAuthStore((state) => state.user);
    const [counts, setCounts] = useState({ totalHouses: 0, totalPlots: 0 });

    const fetchCounts = async () => {
        try {
            const response = await axiosInstancev1.get("/properties/counts");
            if (response.data.success) {
                setCounts({
                    totalHouses: response.data.totalHouses,
                    totalPlots: response.data.totalPlots
                });
            }
        } catch (error) {
            console.error("Error fetching counts:", error);
        }
    };

    useEffect(() => {
        fetchCounts();
    }, []);

    return (
        <div style={{ backgroundColor: "#E0E0E0" }}>
            <Layout>
                <div className="p-2">
                    <AgentBanner
                        name={user?.name || "Real Estate Agent"}
                        role={user?.role === 'real_estate_agent' ? "Real Estate Agent" : "Agent"}
                        housingCount={counts.totalHouses}
                        plotCount={counts.totalPlots}
                    />
                </div>
            </Layout>
        </div>
    );
};

export default Profile;
